import { makeStyles } from 'tss-react/mui';

import { GLOBAL_SNACKBAR_WIDGET_WIDTH_PX } from '~/components/GlobalSnackbarStack/constants';

const useStyles = makeStyles()((theme) => ({
  container: {
    // Positioning is owned by the shared GlobalSnackbarStack. The `square`
    // prop on `<Accordion>` disables MUI's stacked-accordion corner
    // machinery so this 12px applies to all four corners uncontested; the
    // `:last-child` override then squares the bottom corners when the
    // widget is the bottom-most stack child so the card sits flush with
    // the viewport (matching the activation snackbar's pattern) and
    // doesn't obscure the vehicle-list pagination.
    '&:last-child': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    backgroundColor: theme.new.color.grey[900],
    color: theme.new.color.common.white,
    borderRadius: '12px',
    width: GLOBAL_SNACKBAR_WIDGET_WIDTH_PX,
    '&::before': {
      display: 'none',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '48px',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
    '& .MuiAccordionSummary-expandIconWrapper svg': {
      fill: theme.new.color.common.white,
    },
  },
  summary: {
    '& svg': {
      width: '20px',
      height: '20px',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    '& svg path': {
      stroke: theme.new.color.common.white,
    },
  },
  summaryDisabled: {
    '&:hover': {
      cursor: 'default',
    },
  },
  closeButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    '&:focus': {
      outline: `2px solid ${theme.new.color.brandPrimary}`,
    },
  },
  singleContainer: {
    display: 'flex',
    padding: '16px',
    alignItems: 'center',
    width: 'auto',
    gap: '2px',
  },
  loadingIcon: {
    minHeight: 'auto',
    width: '20px',
    height: '20px',
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
  details: {
    padding: '0px 16px 16px',
  },
  fileName: {
    display: 'block',
    marginBottom: '12px',
  },
  progressBarContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '8px',
    gap: '8px',
  },
  progressBar: {
    height: '4px',
    flex: '1 1 auto',
    backgroundColor: theme.new.color.grey[300],
  },
  progressBarFill: {
    height: '100%',
    backgroundColor: theme.new.color.brandPrimary,
  },
  viewResultsButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  resultsDescriptionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '& svg': {
      stroke: theme.new.color.common.white,
      width: '16px',
      height: '16px',
      '& path': {
        stroke: theme.new.color.common.white,
      },
    },
  },
}));

export default useStyles;
